export default "__VITE_ASSET__yX3BTQ9S__"